import { useTranslation } from 'next-i18next'
import OrganizerIcon from 'assets/icons/nucleo/18px_laptop-chart-line.svg'
import { NavigationItem } from 'components/Layout/Header/DisciplineContent/NavigationItem'
import { minWidthIcon } from 'components/Layout/Header/Header.style'
import { NextLinkWithoutDecoration } from 'components/common/Link'

export const OrganizerButton = () => {
  const { t } = useTranslation('home')
  return (
    <NextLinkWithoutDecoration href="/dashboard" passHref target="_blank">
      <NavigationItem
        leftIcon={<OrganizerIcon css={minWidthIcon} />}
        text={t('organizerSpace')}
      />
    </NextLinkWithoutDecoration>
  )
}
